import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { FALL_ACTIVITY_COUNT, FALL_BINGO_SEASON } from "./fallBingoData";
import { createFallBingoPrizeFile, downloadFallBingoPrizeFile } from "./fallBingoPrize";

export default function FallBingoPrizeModal({ name, gender, completedAt, onNameChange, onGenderChange, onClose }) {
  const navigate = useNavigate();
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  const ready = preview && preview.name === name && preview.gender === gender && preview.completedAt === completedAt;

  useEffect(() => {
    let active = true;
    let url;
    setPreview(null);
    setError("");
    createFallBingoPrizeFile(name, FALL_BINGO_SEASON, completedAt, gender).then((file) => {
      if (!active) return;
      url = URL.createObjectURL(file);
      setPreview({ file, url, name, gender, completedAt });
    }).catch((failure) => {
      if (active) setError(failure.message || "Your card could not be created. Please try again.");
    });
    return () => {
      active = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [name, gender, completedAt, attempt]);

  function shareToFeed() {
    if (!ready) return;
    // Use the challenge dashboard's image handoff to the existing post composer.
    navigate("/", { state: {
      createdImage: preview.file,
      prefillPostMessage: `I completed all ${FALL_ACTIVITY_COUNT} adventures in Fall Bingo and earned my Fall Adventure Champion card! 🍁`,
    } });
  }

  return <Modal show onHide={onClose} centered dialogClassName="fall-bingo-prize-dialog" contentClassName="fall-bingo-prize-modal" aria-labelledby="fall-bingo-prize-title">
    <Modal.Header><Modal.Title id="fall-bingo-prize-title">Your Fall finisher card</Modal.Title><button type="button" className="fall-bingo-prize-close" aria-label="Close finisher card" onClick={onClose}>×</button></Modal.Header>
    <Modal.Body>
      <div className="fall-bingo-prize-preview" aria-busy={!ready && !error}>
        {ready && <img src={preview.url} alt={`Fall Adventure Champion finisher card for ${name.trim() || "Fall adventurer"}`} />}
        {!ready && !error && <p role="status">Creating your finisher card…</p>}
        {error && <div><p role="alert">{error}</p><button type="button" onClick={() => setAttempt((current) => current + 1)}>Try again</button></div>}
      </div>
      <div className="fall-bingo-prize-personalize">
        <label htmlFor="fall-bingo-prize-name">Name on your card</label>
        <input id="fall-bingo-prize-name" maxLength={80} value={name} onChange={(event) => onNameChange(event.target.value)} placeholder="Your name here" />
        <fieldset className="fall-bingo-gender" aria-label="Champion character"><div className="fall-bingo-gender-buttons">{["female", "male"].map((choice) => <button type="button" key={choice} aria-pressed={gender === choice} onClick={() => onGenderChange(choice)}>{choice === "female" ? "Female" : "Male"}</button>)}</div></fieldset>
      </div>
      <div className="fall-bingo-prize-actions">
        <button type="button" disabled={!ready} onClick={() => downloadFallBingoPrizeFile(preview.file)}>Download ↓</button>
        <button type="button" disabled={!ready} onClick={shareToFeed}>Share to Feed</button>
      </div>
    </Modal.Body>
  </Modal>;
}
